export const Types = {
  CREATING_PASSWORD: '@cardPassword/CREATING_PASSWORD',
};

type TypeCreatingPassword = {
  type: string;
  payload: boolean | null;
};

export function setCreatingPassword(
  value: boolean | null,
): TypeCreatingPassword {
  return {
    type: Types.CREATING_PASSWORD,
    payload: value,
  };
}
